import SmsToggle from "../messageConfiguration/sms/smsToggle";
import EmailToggle from "../messageConfiguration/email/emailToggle";
import AppToggle from "../messageConfiguration/app/appToggle";
import React from "react";
class MessageConfigurationDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: "",
      message: {},
      Message_Configuration_Sms_Feature_ID: 175,
      Message_Configuration_Email_Feature_ID: 176,
      Message_Configuration_App_Feature_ID: 177
    };

    this.changeMenu = this.changeMenu.bind(this);
  }
  changeMenu(e, menu) {
    e.preventDefault();

    this.setState({ activeMenu: menu });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.message) {
      this.setState({ message: nextProps.message });
      if (nextProps.message.bySMS) {
        this.setState({ activeMenu: "By Sms" });
      } else if (nextProps.message.byEMAIL) {
        this.setState({ activeMenu: "By Mail" });
      }
      // if (nextProps.message.byAPP) {
      else this.setState({ activeMenu: "By App" });
      // }
    }
  }
  componentDidMount() {
    const {
      Message_Configuration_Sms_Feature_ID,
      Message_Configuration_Email_Feature_ID,
      Message_Configuration_App_Feature_ID
    } = this.state;
    const accessSpecifier = this.props.accessSpecifier;
    if (this.props && this.props.message) {
      this.setState({ message: this.props.message });
      if (
        this.props.message.bySMS &&
        accessSpecifier[Message_Configuration_Sms_Feature_ID] &&
        accessSpecifier[Message_Configuration_Sms_Feature_ID].viewP
      ) {
        this.setState({ activeMenu: "By Sms" });
      } else if (
        this.props.message.byEMAIL &&
        accessSpecifier[Message_Configuration_Email_Feature_ID] &&
        accessSpecifier[Message_Configuration_Email_Feature_ID].viewP
      ) {
        this.setState({ activeMenu: "By Mail" });
      }
      // if (this.props.message.byAPP) {
      else this.setState({ activeMenu: "By App" });
      // }
    }
  }
  render() {
    const {
      activeMenu,
      message,
      Message_Configuration_Sms_Feature_ID,
      Message_Configuration_Email_Feature_ID,
      Message_Configuration_App_Feature_ID
    } = this.state;
    const accessSpecifier = this.props.accessSpecifier;
    // const message = this.props.message;
    return (
      <>
        <div className="tab-style-1">
          <div
            className="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            {message &&
            message.bySMS &&
            accessSpecifier[Message_Configuration_Sms_Feature_ID] &&
            accessSpecifier[Message_Configuration_Sms_Feature_ID].viewP ? (
              <>
                <a
                  className={
                    activeMenu === "By Sms" ? "nav-link active" : "nav-link"
                  }
                  id="serv-tab"
                  data-toggle="pill"
                  href="#serv"
                  role="tab"
                  aria-controls="serv"
                  aria-selected="true"
                  onClick={e => {
                    this.changeMenu(e, "By Sms");
                  }}
                >
                  <span>Sms Template</span>
                </a>
              </>
            ) : null}
            {message &&
            message.byAPP &&
            accessSpecifier[Message_Configuration_App_Feature_ID] &&
            accessSpecifier[Message_Configuration_App_Feature_ID].viewP ? (
              <a
                className={
                  activeMenu === "By App" ? "nav-link active" : "nav-link"
                }
                id="role-tab"
                data-toggle="pill"
                href="#role"
                role="tab"
                aria-controls="role"
                aria-selected="false"
                onClick={e => {
                  this.changeMenu(e, "By App");
                }}
              >
                <span>App Template</span>
              </a>
            ) : null}
            {message &&
            message.byEMAIL &&
            accessSpecifier[Message_Configuration_Email_Feature_ID] &&
            accessSpecifier[Message_Configuration_Email_Feature_ID].viewP ? (
              <a
                className={
                  activeMenu === "By Mail" ? "nav-link active" : "nav-link"
                }
                id="doc-tab"
                data-toggle="pill"
                href="#doc"
                role="tab"
                aria-controls="doc"
                aria-selected="false"
                onClick={e => {
                  this.changeMenu(e, "By Mail");
                }}
              >
                <span>Email Template</span>
              </a>
            ) : null}
          </div>
          <div className="tab-content" id="v-pills-tabContent">
            {activeMenu === "By Sms" &&
            accessSpecifier[Message_Configuration_Sms_Feature_ID] &&
            accessSpecifier[Message_Configuration_Sms_Feature_ID].viewP ? (
              <SmsToggle message={message} accessSpecifier={accessSpecifier} />
            ) : null}
            {activeMenu === "By App" &&
            accessSpecifier[Message_Configuration_App_Feature_ID] &&
            accessSpecifier[Message_Configuration_App_Feature_ID].viewP ? (
              <AppToggle message={message} accessSpecifier={accessSpecifier} />
            ) : null}
            {activeMenu === "By Mail" &&
            accessSpecifier[Message_Configuration_Email_Feature_ID] &&
            accessSpecifier[Message_Configuration_Email_Feature_ID].viewP ? (
              <EmailToggle
                message={message}
                accessSpecifier={accessSpecifier}
              />
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default MessageConfigurationDetail;
